export const LOAD_PROJECT_DATA = "LOAD_PROJECT_DATA";
export const GET_PROJECT_DATA  = "GET_PROJECT_DATA";

//Edit Project

export const EDIT_PROJECT = "EDIT_PROJECT";
export const EDIT_USER_PROJECT = "EDIT_USER_PROJECT";

export const RESET_SINGLE_PROJECT_DATA = "RESET_SINGLE_PROJECT_DATA";